import React from "react"

const QuyTrinhTiepNhanVaGiaiQuyetKhieuNai = () => {
  return (
    <>
      <p>
        <strong>QUY TRÌNH TIẾP NHẬN VÀ GIẢI QUYẾT KHIẾU NẠI</strong>
      </p>

      <p>
        <strong>
          <em>(Áp dụng từ ngày 21/8/2025)</em>
        </strong>
      </p>

      <p>
        <strong>I. Mục đích</strong>
      </p>

      <p>Quy trình này được ban hành nhằm:</p>

      <ul className="list-disc pl-5">
        <li>Thiết lập cơ chế tiếp nhận và giải quyết khiếu nại minh bạch.</li>
        <li>Đảm bảo quyền và lợi ích hợp pháp của người sử dụng dịch vụ ON Live TV.</li>
        <li>Nâng cao chất lượng dịch vụ thông qua việc tiếp nhận phản hồi từ người dùng.</li>
        <li>Tuân thủ quy định của pháp luật Việt Nam về bảo vệ quyền lợi người tiêu dùng.</li>
      </ul>

      <p>
        <strong>II. Phạm vi áp dụng</strong>
      </p>

      <p>
        Quy trình tiếp nhận và giải quyết khiếu nại áp dụng đối với tất cả người dùng sử dụng dịch vụ ON Live TV có phát
        sinh khiếu nại, phản ánh hoặc yêu cầu hỗ trợ liên quan đến việc sử dụng sản phẩm, dịch vụ và các tính năng trên
        nền tảng ON Live TV.
      </p>

      <p>Phạm vi tiếp nhận và giải quyết khiếu nại bao gồm nhưng không giới hạn các nội dung sau:</p>

      <ul className="list-disc pl-5">
        <li>Đăng ký, đăng nhập, xác thực và quản lý tài khoản người dùng;</li>
        <li>Dịch vụ xem truyền hình trực tiếp (Livestream);</li>
        <li>Dịch vụ Video theo yêu cầu (VOD);</li>
        <li>Gói thuê bao, quyền truy cập nội dung và các dịch vụ trả phí;</li>
        <li>Thanh toán, gia hạn, hủy gói dịch vụ, hoàn tiền và các vấn đề liên quan đến giao dịch;</li>
        <li>Chương trình khuyến mại, ưu đãi, quà tặng và các hoạt động chăm sóc khách hàng;</li>
        <li>Thông tin tài khoản, dữ liệu cá nhân và việc xử lý dữ liệu theo quy định của pháp luật;</li>
        <li>
          Chất lượng dịch vụ, lỗi kỹ thuật, sự cố hệ thống và các tính năng được cung cấp trên nền tảng ON Live TV;
        </li>
        <li>Các vấn đề khác liên quan đến việc cung cấp và sử dụng dịch vụ ON Live TV.</li>
      </ul>

      <p>
        <strong>III. Nguyên tắc giải quyết khiếu nại</strong>
      </p>

      <p>ON Live TV thực hiện việc tiếp nhận và giải quyết khiếu nại trên các nguyên tắc sau:</p>

      <p>
        <strong>Công khai</strong>
      </p>

      <p>Quy trình, thời gian xử lý và kết quả được thông báo minh bạch.</p>

      <p>
        <strong>Khách quan</strong>
      </p>

      <p>Mọi khiếu nại đều được xem xét dựa trên:</p>

      <ul className="list-disc pl-5">
        <li>Thông tin người dùng cung cấp;</li>
        <li>Dữ liệu hệ thống;</li>
        <li>Lịch sử giao dịch;</li>
        <li>Quy định của ON Live TV.</li>
      </ul>

      <p>
        <strong>Bình đẳng</strong>
      </p>

      <p>Mọi người dùng đều được tiếp nhận và xử lý theo cùng quy trình.</p>

      <p>
        <strong>Bảo mật</strong>
      </p>

      <p>ON Live TV cam kết thông tin cá nhân chỉ được sử dụng phục vụ việc xác minh và giải quyết khiếu nại.</p>

      <p>
        <strong>Kênh liên hệ</strong>
      </p>

      <p>
        Nếu có bất kỳ thắc mắc, thông tin nào cần làm rõ hoặc khiếu nại về chất lượng dịch vụ, Khách hàng có thể liên hệ
        Công ty Cổ phần Truyền hình Tương tác Việt Nam:
      </p>

      <p>- Trụ sở chính: Số 3 Ngõ 84 Ngọc Khánh, phường Giảng Võ, Thành phố Hà Nội</p>

      <p>- Hotline: 1900.866.666 (miễn phí)</p>

      <p>
        - Email: <a href="mailto:hotro@onlive.vn">hotro@onlive.vn</a>
      </p>

      <p>
        <strong>IV. Quy trình tiếp nhận và giải quyết khiếu nại</strong>
      </p>

      <p>
        <strong>1. Tài khoản</strong>
      </p>

      <p>
        <strong>Phạm vi áp dụng:</strong>
      </p>

      <p>Bao gồm nhưng không giới hạn:</p>

      <ul className="list-disc pl-5">
        <li>Không đăng nhập được tài khoản.</li>
        <li>Quên mật khẩu.</li>
        <li>Không nhận mã OTP.</li>
        <li>Sai thông tin tài khoản.</li>
        <li>Tài khoản bị khóa hoặc bị hạn chế truy cập.</li>
        <li>Không thể cập nhật thông tin tài khoản.</li>
      </ul>

      <p>
        <strong>Cách thức xử lý:</strong>
      </p>

      <p>
        Sau khi tiếp nhận yêu cầu, ON Live TV sẽ xác minh thông tin tài khoản thông qua các thông tin người dùng đã đăng
        ký như UID, email, số điện thoại hoặc các thông tin xác thực khác.
      </p>

      <p>
        Trên cơ sở kết quả xác minh, ON Live TV sẽ kiểm tra trạng thái tài khoản và xác định nguyên nhân dẫn đến sự cố,
        bao gồm:
      </p>

      <ul className="list-disc pl-5">
        <li>Thông tin đăng nhập không chính xác;</li>
        <li>Tài khoản chưa được kích hoạt;</li>
        <li>Tài khoản bị khóa theo Điều khoản sử dụng;</li>
        <li>Lỗi phát sinh trong quá trình xác thực;</li>
        <li>Các nguyên nhân kỹ thuật khác.</li>
      </ul>

      <p>Tùy từng trường hợp, ON Live TV sẽ:</p>

      <ul className="list-disc pl-5">
        <li>Hướng dẫn người dùng đặt lại mật khẩu;</li>
        <li>Gửi lại mã OTP nếu đáp ứng điều kiện xác thực;</li>
        <li>Khôi phục quyền truy cập đối với tài khoản đủ điều kiện;</li>
        <li>Cập nhật hoặc điều chỉnh thông tin tài khoản theo yêu cầu hợp lệ của người dùng.</li>
      </ul>

      <p>
        Kết quả xử lý sẽ được thông báo thông qua chính kênh mà người dùng đã gửi yêu cầu hoặc các kênh liên hệ đã đăng
        ký.
      </p>

      <p>
        <strong>2. Gói dịch vụ</strong>
      </p>

      <p>
        <strong>Phạm vi áp dụng:</strong>
      </p>

      <p>Bao gồm:</p>

      <ul className="list-disc pl-5">
        <li>Không kích hoạt được gói dịch vụ.</li>
        <li>Gia hạn không thành công.</li>
        <li>Hủy gói không thành công.</li>
        <li>Quyền lợi gói dịch vụ không đúng như công bố.</li>
        <li>Không sử dụng được các tính năng thuộc gói đã đăng ký.</li>
      </ul>

      <p>
        <strong>Cách thức xử lý:</strong>
      </p>

      <p>
        ON Live TV sẽ tiến hành kiểm tra thông tin đăng ký dịch vụ của người dùng, bao gồm loại gói, thời điểm đăng ký,
        thời hạn sử dụng và trạng thái hiệu lực của gói dịch vụ.
      </p>

      <p>
        Trong trường hợp phát hiện sự khác biệt giữa thông tin người dùng phản ánh và dữ liệu ghi nhận trên hệ thống, ON
        Live TV sẽ tiến hành đối chiếu để xác định nguyên nhân, chẳng hạn:
      </p>

      <ul className="list-disc pl-5">
        <li>Giao dịch đăng ký chưa hoàn tất;</li>
        <li>Gói dịch vụ đã hết hiệu lực;</li>
        <li>Người dùng chưa đáp ứng điều kiện sử dụng;</li>
        <li>Phát sinh lỗi trong quá trình kích hoạt dịch vụ.</li>
      </ul>

      <p>
        Sau khi xác minh, ON Live TV sẽ thực hiện các biện pháp cần thiết để khôi phục quyền sử dụng hợp lệ của người
        dùng đồng thời hướng dẫn các thao tác cần thiết nếu vấn đề phát sinh từ phía người sử dụng.
      </p>

      <p>
        <strong>3. Thanh toán</strong>
      </p>

      <p>
        <strong>Phạm vi áp dụng:</strong>
      </p>

      <p>Bao gồm:</p>

      <ul className="list-disc pl-5">
        <li>Đã thanh toán nhưng chưa kích hoạt dịch vụ.</li>
        <li>Thanh toán không thành công.</li>
        <li>Giao dịch bị trừ tiền nhiều lần.</li>
        <li>Sai số tiền thanh toán.</li>
        <li>Không ghi nhận giao dịch.</li>
        <li>Không nhận được hóa đơn hoặc chứng từ thanh toán (nếu có).</li>
      </ul>

      <p>
        <strong>Cách thức xử lý:</strong>
      </p>

      <p>
        Đối với các khiếu nại liên quan đến thanh toán, ON Live TV sẽ kiểm tra thông tin giao dịch do người dùng cung
        cấp, bao gồm mã giao dịch, thời điểm thanh toán, phương thức thanh toán và tài khoản sử dụng.
      </p>

      <p>
        Đồng thời, ON Live TV sẽ đối chiếu dữ liệu giao dịch với hệ thống thanh toán và các đối tác cung cấp dịch vụ
        thanh toán nhằm xác định tình trạng thực tế của giao dịch.
      </p>

      <p>Trên cơ sở kết quả xác minh, ON Live TV sẽ:</p>

      <ul className="list-disc pl-5">
        <li>Kích hoạt dịch vụ nếu giao dịch đã được xác nhận thành công nhưng chưa được cập nhật;</li>
        <li>Điều chỉnh trạng thái giao dịch trong trường hợp phát sinh sai lệch;</li>
        <li>Phối hợp với đối tác thanh toán để xử lý đối với các giao dịch cần xác minh thêm;</li>
        <li>
          Thực hiện hoàn tiền hoặc các biện pháp xử lý khác theo Chính sách thanh toán và hoàn tiền của ON Live TV (nếu
          thuộc trường hợp áp dụng).
        </li>
      </ul>

      <p>
        Trong trường hợp cần làm việc với ngân hàng, tổ chức trung gian thanh toán hoặc nhà mạng, thời gian xử lý có thể
        kéo dài hơn so với thời gian xử lý thông thường. ON Live TV sẽ chủ động cập nhật tiến độ tới người dùng.
      </p>

      <p>
        <strong>4. Nội dung</strong>
      </p>

      <p>
        <strong>Phạm vi áp dụng:</strong>
      </p>

      <p>Bao gồm:</p>

      <ul className="list-disc pl-5">
        <li>Không xem được Livestream.</li>
        <li>Không xem được nội dung theo yêu cầu (VOD).</li>
        <li>Thiếu nội dung.</li>
        <li>Nội dung phát không đúng lịch công bố.</li>
        <li>Nội dung không đúng mô tả.</li>
        <li>Không truy cập được nội dung đã đăng ký.</li>
        <li>Nội dung bị giới hạn truy cập.</li>
      </ul>

      <p>
        <strong>Cách thức xử lý:</strong>
      </p>

      <p>
        Sau khi tiếp nhận phản ánh, ON Live TV sẽ xác minh nội dung mà người dùng đang truy cập, thời điểm phát sinh sự
        cố, loại thiết bị sử dụng và quyền truy cập của tài khoản đối với nội dung đó.
      </p>

      <p>Quá trình xác minh nhằm xác định nguyên nhân phát sinh, bao gồm:</p>

      <ul className="list-disc pl-5">
        <li>Nội dung thuộc gói dịch vụ mà người dùng chưa đăng ký;</li>
        <li>Nội dung đã kết thúc thời gian phát hành;</li>
        <li>Điều chỉnh lịch phát sóng từ đơn vị sở hữu nội dung;</li>
        <li>Giới hạn bản quyền theo khu vực hoặc thiết bị;</li>
        <li>Sự cố kỹ thuật ảnh hưởng đến việc cung cấp nội dung.</li>
      </ul>

      <p>
        Trường hợp phát hiện lỗi thuộc phạm vi cung cấp dịch vụ của ON Live TV, hệ thống sẽ được cập nhật hoặc điều
        chỉnh trong thời gian sớm nhất. Nếu nội dung không thể cung cấp do quy định bản quyền hoặc các nguyên nhân khách
        quan khác, ON Live TV sẽ thông báo rõ lý do để người dùng nắm được.
      </p>

      <p>
        <strong>5. Chất lượng nền tảng</strong>
      </p>

      <p>
        <strong>Phạm vi áp dụng:</strong>
      </p>

      <p>Bao gồm:</p>

      <ul className="list-disc pl-5">
        <li>Video bị giật hoặc đứng hình.</li>
        <li>Video tải chậm hoặc liên tục hiển thị trạng thái chờ.</li>
        <li>Không có hình ảnh hoặc âm thanh.</li>
        <li>Chất lượng hình ảnh thấp.</li>
        <li>Ứng dụng bị thoát đột ngột.</li>
        <li>Không thể phát video trên một số thiết bị.</li>
      </ul>

      <p>
        <strong>Cách thức xử lý:</strong>
      </p>

      <p>
        ON Live TV sẽ xác minh các thông tin liên quan đến môi trường sử dụng dịch vụ như loại thiết bị, hệ điều hành,
        phiên bản ứng dụng, kết nối Internet và thời điểm phát sinh sự cố.
      </p>

      <p>
        Đồng thời, ON Live TV sẽ đánh giá phạm vi ảnh hưởng của sự cố để xác định đây là trường hợp chỉ xảy ra với một
        người dùng, một nhóm người dùng hay là sự cố ảnh hưởng trên diện rộng.
      </p>

      <p>
        Trên cơ sở kết quả xác minh, ON Live TV sẽ hướng dẫn người dùng thực hiện các biện pháp khắc phục phù hợp hoặc
        tiến hành xử lý đối với các sự cố thuộc phạm vi cung cấp dịch vụ.
      </p>

      <p>
        Trong trường hợp xảy ra sự cố ảnh hưởng đến nhiều người dùng, ON Live TV sẽ ưu tiên khắc phục trong thời gian
        sớm nhất và chủ động cập nhật tình trạng xử lý thông qua các kênh thông tin chính thức.
      </p>

      <p>
        <strong>6. Chương trình khuyến mại</strong>
      </p>

      <p>
        <strong>Phạm vi áp dụng:</strong>
      </p>

      <p>Bao gồm:</p>

      <ul className="list-disc pl-5">
        <li>Không nhận được Giftcode.</li>
        <li>Không ghi nhận điểm thưởng.</li>
        <li>Không nhận được quà tặng.</li>
        <li>Không ghi nhận điều kiện tham gia chương trình.</li>
        <li>Sai kết quả chương trình.</li>
      </ul>

      <p>
        <strong>Cách thức xử lý:</strong>
      </p>

      <p>
        ON Live TV sẽ kiểm tra thông tin chương trình, thời gian tham gia, điều kiện áp dụng và dữ liệu ghi nhận trên hệ
        thống để xác định quyền lợi của người dùng.
      </p>

      <p>
        Trong trường hợp người dùng đáp ứng đầy đủ điều kiện theo thể lệ chương trình nhưng quyền lợi chưa được ghi
        nhận, ON Live TV sẽ thực hiện điều chỉnh hoặc bổ sung quyền lợi tương ứng theo quy định của chương trình.
      </p>

      <p>
        Nếu người dùng không đáp ứng các điều kiện tham gia hoặc chương trình đã kết thúc theo thể lệ công bố, ON Live
        TV sẽ giải thích rõ căn cứ xử lý để người dùng hiểu và đối chiếu.
      </p>

      <p>
        <strong>7. Dữ liệu cá nhân</strong>
      </p>

      <p>
        <strong>Phạm vi áp dụng:</strong>
      </p>

      <p>Bao gồm:</p>

      <ul className="list-disc pl-5">
        <li>Yêu cầu cập nhật thông tin cá nhân.</li>
        <li>Yêu cầu chỉnh sửa dữ liệu.</li>
        <li>Yêu cầu xóa tài khoản.</li>
        <li>Yêu cầu xóa hoặc hạn chế xử lý dữ liệu cá nhân.</li>
        <li>Khiếu nại liên quan đến việc thu thập, sử dụng hoặc bảo vệ dữ liệu cá nhân.</li>
      </ul>

      <p>
        <strong>Cách thức xử lý:</strong>
      </p>

      <p>
        ON Live TV sẽ xác minh danh tính của người yêu cầu trước khi xử lý nhằm bảo đảm an toàn và bảo mật thông tin.
      </p>

      <p>
        Các yêu cầu sẽ được xem xét trên cơ sở quy định của pháp luật hiện hành và Chính sách bảo vệ dữ liệu cá nhân của
        ON Live TV.
      </p>

      <p>
        Sau khi hoàn tất việc xác minh, ON Live TV sẽ thông báo kết quả xử lý, bao gồm việc chấp thuận, từ chối hoặc yêu
        cầu bổ sung thông tin (nếu cần), đồng thời nêu rõ căn cứ xử lý đối với từng trường hợp.
      </p>

      <p>
        <strong>V. Thời hạn giải quyết khiếu nại</strong>
      </p>

      <p>
        ON Live TV cam kết tiếp nhận, xem xét và giải quyết các yêu cầu, khiếu nại của người dùng trong thời gian hợp
        lý, phù hợp với tính chất và mức độ của từng vụ việc.
      </p>

      <p>
        Thời gian xử lý được tính kể từ thời điểm ON Live TV nhận được đầy đủ thông tin và tài liệu cần thiết để xác
        minh nội dung khiếu nại.
      </p>

      <p>
        Trong trường hợp người dùng chưa cung cấp đầy đủ thông tin hoặc cần bổ sung tài liệu, thời gian xử lý được tính
        lại kể từ thời điểm ON Live TV nhận đủ thông tin bổ sung.
      </p>

      <p>
        <strong>Thời gian phản hồi ban đầu:</strong>
      </p>

      <p>
        Sau khi tiếp nhận yêu cầu, ON Live TV sẽ gửi thông báo xác nhận đã tiếp nhận thông tin thông qua kênh liên hệ mà
        người dùng đã cung cấp.
      </p>

      <p>
        <strong>Thời gian xử lý dự kiến:</strong>
      </p>

      <table>
        <thead>
          <tr>
            <th>Nội dung khiếu nại</th>
            <th>Thời gian xử lý dự kiến</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Tài khoản</td>
            <td>01 - 03 ngày làm việc</td>
          </tr>
          <tr>
            <td>Gói dịch vụ</td>
            <td>01 - 03 ngày làm việc</td>
          </tr>
          <tr>
            <td>Thanh toán</td>
            <td>03 - 05 ngày làm việc</td>
          </tr>
          <tr>
            <td>Nội dung và chất lượng dịch vụ</td>
            <td>01 - 05 ngày làm việc</td>
          </tr>
          <tr>
            <td>Chương trình khuyến mại</td>
            <td>03 - 07 ngày làm việc</td>
          </tr>
          <tr>
            <td>Dữ liệu cá nhân</td>
            <td>Theo quy định của pháp luật hiện hành</td>
          </tr>
          <tr>
            <td>Các trường hợp khác</td>
            <td>Theo tính chất của vụ việc</td>
          </tr>
        </tbody>
      </table>

      <p>
        <strong>VI. Quyền và trách nhiệm của người sử dụng dịch vụ</strong>
      </p>

      <p>
        <strong>1. Quyền của người sử dụng</strong>
      </p>

      <p>Người dùng có quyền:</p>

      <ul className="list-disc pl-5">
        <li>Được gửi yêu cầu hỗ trợ, phản ánh hoặc khiếu nại đối với dịch vụ do VTVlive cung cấp.</li>
        <li>Được tiếp nhận và giải quyết khiếu nại theo quy trình đã công bố.</li>
        <li>Được cung cấp thông tin về tiến độ xử lý khiếu nại.</li>
        <li>Được giải thích kết quả giải quyết khiếu nại.</li>
        <li>Được bảo vệ thông tin cá nhân trong suốt quá trình xử lý.</li>
        <li>Được yêu cầu chỉnh sửa thông tin nếu phát hiện có sai sót.</li>
        <li>Được khiếu nại tiếp nếu không đồng ý với kết quả giải quyết.</li>
        <li>Được thực hiện các quyền khác theo quy định của pháp luật.</li>
        <li>
          Trường hợp VTVlive cung cấp thông tin không chính xác hoặc không đầy đủ theo quy định tại Điều 37 Luật Bảo vệ
          quyền lợi người tiêu dùng (bao gồm thông tin về dịch vụ, giá cả, phương thức thanh toán,...), khách hàng có
          các quyền sau đây đối với giao dịch đã thực hiện (hoặc Hợp đồng đã giao kết, nếu có):
        </li>
      </ul>

      <p>
        <strong>(1) Thỏa thuận lựa chọn cách thức xử lý:</strong> Khách hàng có quyền thỏa thuận với VTVlive về việc
        điều chỉnh, bổ sung hoặc thay đổi cách thức thực hiện giao dịch để đảm bảo quyền lợi.
      </p>

      <p>
        <strong>(2) Đơn phương chấm dứt giao dịch:</strong> Trong thời hạn 30 ngày kể từ ngày giao kết, Khách hàng có
        quyền đơn phương chấm dứt thực hiện và thông báo cho VTVlive. Khách hàng không phải trả bất kỳ chi phí nào để
        chấm dứt, trừ chi phí đối với phần dịch vụ đã sử dụng thực tế.
      </p>

      <p>
        VTVlive sẽ hoàn trả khoản tiền tương ứng với phần dịch vụ ON Live TV chưa sử dụng trong vòng 30 ngày kể từ ngày
        nhận được thông báo chấm dứt.
      </p>

      <p>
        <strong>(3) Yêu cầu tuyên bố giao dịch vô hiệu:</strong> Khách hàng có quyền yêu cầu cơ quan có thẩm quyền tuyên
        bố giao dịch vô hiệu hoặc hủy bỏ theo quy định của pháp luật dân sự.
      </p>

      <p>
        <strong>(4) Yêu cầu bồi thường:</strong> Trường hợp việc cung cấp thông tin không chính xác/đầy đủ gây thiệt hại
        cho khách hàng, hhách hàng có quyền yêu cầu VTVlive bồi thường theo pháp luật dân sự.
      </p>

      <p>
        <strong>2. Trách nhiệm của người sử dụng</strong>
      </p>

      <p>Người dùng có trách nhiệm:</p>

      <ul className="list-disc pl-5">
        <li>Cung cấp thông tin trung thực và chính xác.</li>
        <li>Cung cấp đầy đủ tài liệu chứng minh (nếu có).</li>
        <li>Hợp tác với ON Live TV trong quá trình xác minh.</li>
        <li>Không gửi khiếu nại giả mạo hoặc gian lận.</li>
        <li>Không lợi dụng quyền khiếu nại để gây cản trở hoạt động của hệ thống.</li>
      </ul>

      <p>
        <strong>VII. Quyền và trách nhiệm của ON Live TV</strong>
      </p>

      <p>
        <strong>1. ON Live TV cam kết</strong>
      </p>

      <ul className="list-disc pl-5">
        <li>Tiếp nhận mọi yêu cầu hợp lệ.</li>
        <li>Giải quyết khách quan, minh bạch.</li>
        <li>Bảo mật thông tin người dùng.</li>
        <li>Thông báo tiến độ xử lý.</li>
        <li>Cập nhật kết quả cuối cùng.</li>
        <li>Không thu bất kỳ khoản phí nào đối với việc tiếp nhận và giải quyết khiếu nại.</li>
      </ul>

      <p>
        <strong>2. ON Live TV có quyền</strong>
      </p>

      <ul className="list-disc pl-5">
        <li>Yêu cầu bổ sung thông tin.</li>
        <li>Từ chối yêu cầu không hợp lệ.</li>
        <li>Tạm dừng xử lý khi chưa đủ căn cứ.</li>
        <li>Phối hợp với bên thứ ba khi cần xác minh.</li>
      </ul>

      <p>
        <strong>3. Các trường hợp không thuộc phạm vi giải quyết</strong>
      </p>

      <p>ON Live TV không có nghĩa vụ giải quyết trong các trường hợp:</p>

      <ul className="list-disc pl-5">
        <li>Khiếu nại không liên quan đến dịch vụ ON Live TV.</li>
        <li>Nội dung thuộc trách nhiệm của bên thứ ba.</li>
        <li>Thiết bị của người dùng không đáp ứng yêu cầu tối thiểu.</li>
        <li>Người dùng tự ý can thiệp vào ứng dụng.</li>
        <li>Tài khoản vi phạm Điều khoản sử dụng.</li>
        <li>Người dùng sử dụng phần mềm trái phép.</li>
        <li>Yêu cầu trái quy định pháp luật.</li>
        <li>Các trường hợp bất khả kháng.</li>
      </ul>

      <p>
        <strong>4. Giải quyết tranh chấp</strong>
      </p>

      <ul className="list-disc pl-5">
        <li>
          Trường hợp các bên không đạt được thỏa thuận sau quá trình thương lượng hoặc hòa giải, mỗi bên có quyền yêu
          cầu cơ quan nhà nước có thẩm quyền hoặc Tòa án có thẩm quyền tại Việt Nam giải quyết theo quy định của pháp
          luật.
        </li>
        <li>
          Việc giải quyết tranh chấp được thực hiện theo quy định của pháp luật Việt Nam hiện hành, bao gồm nhưng không
          giới hạn các quy định về bảo vệ quyền lợi người tiêu dùng, giao dịch điện tử, bảo vệ dữ liệu cá nhân và các
          quy định pháp luật có liên quan.
        </li>
        <li>
          Trong thời gian tranh chấp đang được giải quyết, các bên vẫn có trách nhiệm thực hiện các nghĩa vụ không liên
          quan trực tiếp đến nội dung tranh chấp, trừ trường hợp pháp luật có quy định khác hoặc các bên có thỏa thuận
          khác.
        </li>
      </ul>

      <p>
        <strong>VIII. Hiệu lực và cập nhật</strong>
      </p>

      <p>ON Live TV có quyền sửa đổi, bổ sung hoặc cập nhật nội dung của Quy trình này nhằm:</p>

      <ul className="list-disc pl-5">
        <li>Phù hợp với quy định của pháp luật hiện hành;</li>
        <li>Phù hợp với sự thay đổi của dịch vụ, tính năng hoặc phương thức cung cấp dịch vụ;</li>
        <li>Nâng cao chất lượng hỗ trợ và bảo vệ quyền lợi của người sử dụng.</li>
      </ul>

      <p>Mọi thay đổi sẽ được công bố trên ứng dụng và website của ON Live TV trước thời điểm áp dụng.</p>
    </>
  )
}

export default QuyTrinhTiepNhanVaGiaiQuyetKhieuNai
